(ns app.front.view.admin.migration.assign-domain-agenda-templates
  (:require [app.front.view.admin.migration.template :as admin-migration-template]
            [core.front.event :refer [>evt]]))

(defn view [match]
  [admin-migration-template/admin-page-for-migration
   {:task-id   :app.admin.migration.task/assign-domain-agenda-templates-to-committees
    :title     "Assign domain-level agenda templates to committees"
    :help-text (str "This migration finds committees under domain groups that either have no agenda template "
                    "or incorrectly reference a legacy authority group template, and assigns the matching "
                    "domain-level meeting agenda template by name (Authority Group - Committee Name) or the default template."
                    "Requires the domain-level-meetings feature flag to be enabled.")}
   match])

(def route
  {:name        :view/admin.migration.assign-domain-agenda-templates
   :view        view
   :controllers [{:start (fn [_]
                           (>evt [::admin-migration-template/fetch-migration-tasks
                                  :app.admin.migration.task/assign-domain-agenda-templates-to-committees]))}]})
